var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"#272d44","dark":"","fixed":""}},[_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.title)}}),_c('notice-unread-component')],1),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }